export default __webpack_public_path__ + "static/media/013-cake.b9dc0ed6.svg";